<template>
  <div>
    <h1>Registrar sitio</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Sitio (adjuntar archivo .kmz)</label>
              <b-form-file
                v-model="$v.site.file.$model"
                ref="file"
                :state="fileState"
                placeholder="Sitio"
                browse-text="Adjuntar"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                required
                accept=".KMZ"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Nombre del sitio">
                <a-input ref="name" placeholder="Nombre del sitio" v-model="$v.site.name.$model" />
                <small class="text-danger" v-if="!$v.site.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredSite($v.site.name.$model)">Ya existe un registro con este nombre</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Tarifa adicional al banderazo">
                <a-input ref="extraStartedPrice" placeholder="Tarifa adicional al banderazo" v-model="$v.site.extraStartedPrice.$model" />
                <small class="text-danger" v-if="!$v.site.extraStartedPrice.decimal">Campo decimal</small>
                <small class="text-danger" v-if="!$v.site.extraStartedPrice.required">Campo requerido. No debe estar vacío.</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Restricción de inicio de viaje">
                <a-checkbox ref="restriction" v-model="restriction">
                  Restricción de inicio de viaje
                </a-checkbox>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredSite($v.site.name.$model) && !$v.$invalid)">
                  Registrar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required, decimal } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const CREATE_SITE = gql`
  mutation createSite($kmzFile: String, $name: String, $createdBy: String, $limitation: Int, $extraStartedPrice: Float){
    createSite(createSiteInput: { kmzFile: $kmzFile, name: $name, createdBy: $createdBy, limitation: $limitation, extraStartedPrice: $extraStartedPrice }){
      kmzFile
      name
      createdBy
    }
  }
`
const GET_ALL_SITES = gql`
  query getAllSites{
    getAllSites{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      site: {
        file: null,
        name: '',
        limitation: '',
        extraStartedPrice: '',
      },
      restriction: false,
      fileState: null,
      createdBy: this.$store.state.user.email,
      registeredSites: {},
    }
  },
  apollo: {
    getAllSites: {
      query: GET_ALL_SITES,
      context: headers(),
      result({ data }) {
        data.getAllSites.forEach(site => {
          this.registeredSites[site.name] = 1
        })
      },
    },
  },
  methods: {
    onFileSelected(event) {
      this.site.file = event.target.files[0]
      // console.log(this.site.file)
    },
    validateRegisteredSite(name) {
      if (this.registeredSites[name.trim()]) {
        return false
      } else {
        return true
      }
    },
    disableForm() {
      this.$refs.button.disabled = true
      this.$refs.file.disabled = true
      this.$refs.name.disabled = true
      this.$refs.restriction.disabled = true
      this.$refs.extraStartedPrice.disabled = true
    },
    // delete this later
    enableForm() {
      this.$refs.button.disabled = false
      this.$refs.file.disabled = false
      this.$refs.name.disabled = false
      this.$refs.restriction.disabled = false
      this.$refs.extraStartedPrice.disabled = false
    },
    async handleSubmit() {
      const file = []
      file.fileExtension = this.site.file.name.split('.').pop()
      file.fileUploaded = this.site.file
      console.log(file)
      // console.log(this.site.name)
      // this.disableForm()
      // console.log(this.$refs)
      const uploadedFile = await uploadFileS3(file)
      console.log(uploadedFile)
      if (this.restriction === true) {
        this.site.limitation = 1
      } else {
        this.site.limitation = 0
      }
      console.log(uploadedFile.Key, 'upkey')
      console.log(this.site, 'site')
      this.$apollo.mutate({
        mutation: CREATE_SITE,
        context: headers(),
        variables: {
          kmzFile: uploadedFile.Key,
          name: this.site.name,
          createdBy: this.createdBy,
          extraStartedPrice: parseFloat(this.site.extraStartedPrice),
          limitation: parseInt(this.site.limitation),
        },
      })
        .then(data => {
          console.log(data)
          this.$router.push({ name: 'GetSites' })
        })
        .catch(err => {
          console.log(err)
          // this.enableForm()
        })
    },
  },
  validations: {
    site: {
      file: { required },
      name: { required },
      extraStartedPrice: { required, decimal },
      restriction: {},
    },
  },
}
</script>
